module.exports = __webpack_public_path__ + "img/17-19.3e469aa2.jpg";